import { PhoneNumberFormats } from '../phoneNumberFormatsByCountry'

export const CA: PhoneNumberFormats = {
  placeholder: '403 123 1234',
  format: () => '### ### ####',
  phoneNumberMinLength: () => 10
}
